import { DialogContent } from '@material-ui/core/';
import { Theme, withStyles } from '@material-ui/core/styles';

const ClosableDialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: '0 !important',
    }
  },
}))(DialogContent);

export default ClosableDialogContent;
